import { Box, useTheme } from "@mui/material";
import { ControllerRenderProps } from "react-hook-form";

import { DonationPaymentInput } from "../../../../contexts/FormV2Context";

import { useTranslate } from "@/common/hooks/useTranslate";
import { TicketingPaymentInput } from "@/common/types/ticketing";
import { FormCheckbox } from "@/forms-design-system/FormCheckbox";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

interface GiftAidCheckboxProps {
  field?: ControllerRenderProps<DonationPaymentInput | TicketingPaymentInput, "hasGiftAidConfirmation">;
  errorMessage?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const GiftAidCheckbox = ({ field, errorMessage, onChange }: GiftAidCheckboxProps) => {
  const theme = useTheme();
  const { t } = useTranslate();

  if (!theme.palette.forms || !theme.palette.formsComponents?.giftAidBlock) {
    return <InvalidThemeErrorMessage />;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", marginTop: theme.spacing(1) }}>
      <FormCheckbox
        {...field}
        checked={field?.value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          field?.onChange(event);
          onChange?.(event);
        }}
        label={t("donationForm", "giftAidBlock.checkbox.label")}
        size="small"
        error={Boolean(errorMessage)}
        helperText={errorMessage}
      />
    </Box>
  );
};
